<div class="modal-header">
    <h5 class="pt-4 ps-4">Preview de manifiesto: <strong>{{data.mf.nombre}}</strong></h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="pdf-container"><iframe width="100%" height="500px" [src]="getSourceURL(dataWithFile.preview)"></iframe></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="accent" class="text-white mt-4 me-3 mb-3" (click)="openDialogDocMf(data.mf)">Firmar <mat-icon>gesture</mat-icon></button>
</mat-dialog-actions>
